<template>
  <el-card>
    <template v-slot:header>
      <div class="clearfix">
        <span style="font-weight: bold;"><i class="icon iconfont icon-leida" style="font-weight: bold;margin-right: 5px;font-size: 20px;"></i>Annotation Information</span>
      </div>
    </template>
    <div class="container">
      <el-container>
        <el-main>
          <div id="anno" style="width:100%;height:500px;"></div> 
        </el-main>
      </el-container>
    </div>
  </el-card>
</template>
    
<script>
export default {
  props: {
    species: {
      type: String,
      required: true
    },
    tissue: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      chartData: [],
      url: "http://183.175.59.4/devenhancer/",// 后端接口地址
    };
  },
  mounted() {
    this.handleAnalysis();
  },
  methods: {
    handleAnalysis() {
      // 发送请求获取后端数据
      const params = { Species: this.species, Tissue: this.tissue };
      this.$axios.get(this.url + "seanno" + "/", { params }).then((response) => {
          // 对数据进行处理
          const data = response.data;
          if (data && Array.isArray(data) && data.length > 0) {
            const count = {};
            for (let item of data) {
              let annotation = '';
              // 获取annotation字段的数据，并将其作为统计变量
              if (item.annotation) {
                annotation = item.annotation.trim();
                count[annotation] ? count[annotation] ++ : count[annotation] = 1;
              }
            }
            // 将 count 中的数据转换为雷达图所需的格式
            const radarData = [];
            for (let prop in count) {
              radarData.push({
                name: prop,
                value: count[prop]
              })
            }
            // 绘制雷达图
            const chart = this.$echarts.init(document.getElementById('anno'));
            chart.setOption({
              tooltip: {},
              radar: {
                indicator: radarData.map((item) => ({
                  name: item.name,
                  max: Math.max(...radarData.map((i) => i.value)),
                })),
                axisName: { // 设置indicator的字体颜色
                  color: '#000', // 将字体颜色设置为黑色
                },
                shape: 'circle',
                splitArea: {
                  areaStyle: {
                    color: ['#8EC3B0','#DEF5E5', '#BCEAD5', '#9ED5C5', ],
                    shadowColor: 'rgba(0, 0, 0, 0.2)',
                    shadowBlur: 10
                  }
                },
              },
              series: [
                {
                  name: 'Annotation',
                  type: 'radar',
                  data: [
                    {
                      value: radarData.map((item) => item.value),
                      name: 'Radar Chart'
                    },
                  ],
                  lineStyle: {
                    color: '#293B5F' // 这里将线条颜色设置为红色
                  },
                  itemStyle: {
                    color: '#293B5F' // 这里将点的颜色设置为蓝色
                  }
                }
              ]
            });
          } else {
            this.$message.warning('No data found.');
          }
      }).catch(err => {
          console.error(err);
          this.$message.error('Failed to fetch data.');
        });
      },
    }
  }
</script>

<style scoped>
.custom-button1 {
    float: right;
    background-color: #2C3E50;
    border: 1px solid #2C3E50;
    color: #F1F7E7; /* 设置文字颜色为白色，以提高对比度 */
}
.custom-button2 {
    float: right;
    background-color: #2C3E50;
    border: 1px solid #2C3E50;
    color: #F1F7E7; /* 设置文字颜色为白色，以提高对比度 */
    margin-right: 5px;
}
</style>
  


// WEBPACK FOOTER //
// src/components/seAnalysis/Seanno.vue